import React, { useState } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  max-height: ${p => (!p.expanded ? '160px' : '9999px')};
  min-height: 120px;
  transition: max-height 3s ease-in-out;
  overflow: hidden;
  position: relative;
  white-space: pre-line;
`;

const ShowMoreBtn = styled.div`
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 65%
  );
  bottom: 0;
  color: #ccc;
  cursor: pointer;
  font-size: 13px;
  left: 0;
  padding: 6rem 0 1rem;
  position: absolute;
  text-align: center;
  text-decoration-thickness: 0.25em;
  text-decoration: underline;
  text-decoration-color: currentColor;
  text-underline-offset: 6px;
  width: 100%;

  &:hover {
    color: ${p => p.theme.primary600};
  }
`;

export default function ExpandableCopy({ children, ignore = false }) {
  const [isExpanded, setExpanded] = useState(false);

  if (ignore) {
    return children;
  }

  return (
    <Wrapper expanded={isExpanded}>
      {children}
      {!isExpanded && (
        <ShowMoreBtn onClick={() => setExpanded(true)}>Read More</ShowMoreBtn>
      )}
    </Wrapper>
  );
}
